export default {
  dashboardSettings_initial: {
    regional: {
      currency: '$',
      date: 'MM/DD/YYYY, HH:mm'
    }
  },
  dashboardSettings: null
}
